module.exports = __webpack_public_path__ + "img/carousel-1.d946eec7.png";